// extracted by mini-css-extract-plugin
export default {"ns_button_blue":"NSButtonBlue_ns_button_blue__QDts1"};